import { DocumentNode, gql } from '@apollo/client';
import { useDisclosure } from '@chakra-ui/react';
import * as React from 'react';

import { ResourceCarousel } from '@/components/ResourceCarousel';

import { ImageDisplay_PostEmbeddedImageFragment } from './graphql-types/ImageDisplay_PostEmbeddedImageFragment';

import { ImageGrid } from './components/ImageGrid';

export const ImageDisplay: React.FC<{
  postEmbeddedImage?: ImageDisplay_PostEmbeddedImageFragment[];
}> & {
  postEmbeddedImageFragment: DocumentNode;
} = ({ postEmbeddedImage = [] }) => {
  const { isOpen, onClose, onOpen } = useDisclosure();
  const [currentSlide, setCurrentSlide] = React.useState(0);

  const onClickImage = async (index: number): Promise<void> => {
    setCurrentSlide(index);
    onOpen();
  };

  return (
    <>
      <ImageGrid
        urls={postEmbeddedImage.map(
          (embeddedImage) => embeddedImage.postEmbeddedImageProxyThumbnail
        )}
        onClickImage={onClickImage}
      />
      <ResourceCarousel
        isOpen={isOpen}
        onClose={onClose}
        slides={postEmbeddedImage.map((embeddedImage) => {
          return {
            id: embeddedImage.imageId,
            imageProxy:
              embeddedImage.postEmbeddedImageProxyFullSize ?? undefined,
          };
        })}
        currentSlide={currentSlide}
      />
    </>
  );
};
ImageDisplay.postEmbeddedImageFragment = gql`
  fragment ImageDisplay_PostEmbeddedImageFragment on PostEmbeddedImage {
    imageId
    postEmbeddedImageProxyThumbnail: imageProxy(input: { h: 1160 })
    postEmbeddedImageProxyFullSize: imageProxy(input: {})
  }
`;
